import React, { useEffect, useRef } from 'react'

function LoginModal() {
  const formRef = useRef();

  useEffect(() => {
    if (formRef.current) {
      formRef.current.addEventListener("submit", (e) => {
        e.preventDefault();
        const email = formRef.current.querySelector("#email").value;
        const password = formRef.current.querySelector(".password-input").value;
        console.log({ email, password });
        window.location.href = "/dashboard";
      });
    }
  }, [formRef]);


  return (
    <div
      className="modal fade popup"
      id="popup_bid"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div className="modal-body space-y-20 pd-40">
            <div className="wrap-modal flex">
              <div
                className="images flex-none relative"
                style={{ overflow: "auto", maxHeight: "90vh"}}
              >
                <img src="/assets/images/section/bg-login.jpg" alt="images" />
                <div className="mark-logo">
                  <img src="/assets/images/logo/logo2.png" alt="images" />
                </div>
              </div>
              <div className="content">
                <div className="title-login fs-30 fw-7 lh-45">Connexion</div>
                <div className="comments">
                  <div className="respond-comment">
                    <form
                      method="post"
                      className="comment-form form-submit"
                      action="#"
                      acceptCharset="utf-8"
                      ref={formRef}
                    >
                      <fieldset className="">
                        <label className="fw-6">Compte</label>
                        <input
                          type="email"
                          id="email"
                          className="tb-my-input"
                          name="email"
                          placeholder="Email ou nom d'utilisateur"
                        />
                        <img
                          className="img-icon img-email"
                          src="/assets/images/icon/icon-gmail.svg"
                          alt="images"
                        />
                      </fieldset>
                      <fieldset className="style-wrap">
                        <label className="fw-6">Mot de passe</label>
                        <input
                          type="password"
                          className="input-form password-input"
                          placeholder="Mot de passe"
                        />
                        <img
                          className="img-icon"
                          src="/assets/images/icon/icon-password.svg"
                          alt="images"
                        />
                      </fieldset>
                      <div className="title-forgot">
                        <a className="fs-13">Mot de passe oublié</a>{" "}
                      </div>
                      <button className="sc-button" name="submit" type="submit">
                        <span>Se connecter</span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="text-box text-center fs-13">
                  Vous n'avez pas de compte?{" "}
                  <a
                    className="font-2 fw-7 fs-13 color-popup text-color-3"
                    data-toggle="modal"
                    data-target="#popup_bid2"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    Inscrivez-vous
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginModal